<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.imBusinessStatusDesc') }} <a target="_blank" v-if="url" :href="url" class="vendorHistory">{{$t('crm.goVendorHistory')}}</a></h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.currGmv') }}</label>
          <div class="value" v-if="detail.curr_gmv">￥{{ numberFormat(detail.curr_gmv) }}</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.currGmvRank') }}</label>
          <div class="value" v-if="detail.curr_gmv_rank">第{{ detail.curr_gmv_rank }}名</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.mpGrossRate') }}</label>
          <div class="value" v-if="detail.mp_gross_rate">{{Math.round(+detail.mp_gross_rate*10000)/100 }}%</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.gmvIncreaseRateRank') }}</label>
          <div class="value" v-if="detail.gmv_increase_rate_rank">第{{ detail.gmv_increase_rate_rank }}名</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.omsGrossGate') }}</label>
          <div class="value" v-if="detail.oms_gross_rate">{{Math.round(+detail.oms_gross_rate*10000)/100 }}%</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.currSuborderQtyRank') }}</label>
          <div class="value" v-if="detail.curr_suborder_qty_rank">第{{ detail.curr_suborder_qty_rank }}名</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.currSuborderQty') }}</label>
          <div class="value" v-if="detail.curr_suborder_qty">{{ detail.curr_suborder_qty }}</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.suborderQtyIncreaseRateRank') }}</label>
          <div class="value" v-if="detail.suborder_qty_increase_rate_rank">第{{ detail.suborder_qty_increase_rate_rank }}名</div>
          <div class="value" v-else>{{ '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.gmvGraph') }}</h2>
      <div class="chart" ref="chart"></div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.top10BrandList') }}<span class="state">{{ $t('crm.brandListState') }}</span></h2>
      <el-table :data="top10BrandList" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
        <el-table-column prop="brand_name" :label="$t('crm.brandName')"></el-table-column>
        <el-table-column prop="gmv_rank" :label="$t('crm.gmvRank')"></el-table-column>
        <el-table-column prop="gmv_im_rank" :label="$t('crm.brandRank')"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {getImBusinessStatus, getGmvGraph, getTop10BrandList,getFengShenUrl} from '../api';
import * as echarts from "echarts";
import numberFormat from 'number-format.js'

export default {
  data() {
    return {
      detail: {},
      top10BrandList: [],
      url: '',
    };
  },
  methods: {
    fillWeekData(data, weeks, year) {
      const templateLabelMap = {};
      weeks.forEach(date => {
        templateLabelMap[date] = false;
      })
      data.forEach(item => {
        templateLabelMap[item.total_week_seq] = true;
      })
      for (let key in templateLabelMap) {
        if (!templateLabelMap[key]) {
          data.push({
            year_code: year,
            total_week_seq: key,
            gmv_week: 0,
            qty_week: 0,
          })
        }
      }
      return data;
    },
    getChartData() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      getGmvGraph({
        vendorId: this.$route.params.id,
        pageNum: 1,
        pageSize: 200,
      }).then(res => {
        if (res.data.success && res.data.data) {
          let gmvGraphList = [], curGmvGraphList = [], preGmvGraphList = [], curGmv = [], preGmv = [], curOrders = [], preOrders = [];
          gmvGraphList = res.data.data;
          const xAxis = Array(52).fill().map((e,i)=>i+1);
          const date = new Date
          gmvGraphList.map(item=>{
            if(item['year_code'] == date.getFullYear()) {
              curGmvGraphList.push(item);
            }else{
              preGmvGraphList.push(item);
            }
            if(!item.gmv_week) {
              item.gmv_week = 0
            }
            if(!item.qty_week) {
              item.qty_week =0
            }
          })
          this.fillWeekData(curGmvGraphList, xAxis, date.getFullYear())
          this.fillWeekData(preGmvGraphList, xAxis, date.getFullYear()-1)
          curGmvGraphList.sort((a,b)=>{return +a.total_week_seq - +b.total_week_seq});
          preGmvGraphList.sort((a,b)=>{return +a.total_week_seq - +b.total_week_seq});
          curGmvGraphList.map(item=>{
            curGmv.push(+item.gmv_week);
            curOrders.push(+item.qty_week);
          })
          preGmvGraphList.map(item=>{
            preGmv.push(+item.gmv_week);
            preOrders.push(+item.qty_week);
          })

          this.chart.setOption({
            tooltip: {
              trigger: "axis",
              //formatter: '{b0}<br /> {c0}'
            },
            legend: {
              data: ["当前GMV(This Year GMV)", "去年同期GMV(Last Year GMV)", "当前订单数(This Year Orders)", "去年同期订单数(Last Year Orders)"]
            },
            xAxis: {
              type: 'category',
              data: xAxis,
              //name: '日期'
            },
            yAxis: [
              {
                name: '当前GMV(This Year GMV)&去年同期GMV(Last Year GMV)',
                type: 'value',
                nameLocation: 'middle',
                nameGap: 50,
                axisLabel: {
                  formatter: function (value) {
                    return +value/10000+ '万';
                  }
                }
              },
              {
                name: '当前订单数(This Year Orders)&去年同期订单数(Last Year Orders)',
                type: 'value',
                nameLocation: 'middle',
                nameGap: 50,
              },
            ],
            series: [
              {
                name: '当前GMV(This Year GMV)',
                type: 'bar',
                yAxisIndex: 0,
                stack: 'curGmv',
                data: curGmv,
              },
              {
                name: '去年同期GMV(Last Year GMV)',
                type: 'bar',
                yAxisIndex: 0,
                stack: 'preGmv',
                data: preGmv,
              },
              {
                name: '当前订单数(This Year Orders)',
                type: 'line',
                yAxisIndex: 1,
                stack: 'curOrders',
                data: curOrders,
              },
              {
                name: '去年同期订单数(Last Year Orders)',
                type: 'line',
                yAxisIndex: 1,
                stack: 'preOrders',
                data: preOrders
              },
            ]
          });
        }
      })
    },
    numberFormat(value) {
      return numberFormat('###,##0.', value);
    }
  },
  mounted() {
    getImBusinessStatus({
      vendorId: this.$route.params.id,
      pageNum: 1,
      pageSize: 10
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = res.data.data.rows[0];
      }
    })
    getTop10BrandList({
      vendorId: this.$route.params.id,
      pageNum: 1,
      pageSize: 10
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.top10BrandList = res.data.data.rows;
      }
    })
    getFengShenUrl().then(res => {
      if (res.data && res.data.data) {
        this.url = res.data.data;
      }
    })
    this.getChartData();
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 220px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
.chart-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}
.chart {
  margin-top: 20px;
  height: 400px;
}
.vendorHistory {
  font-size: 14px;
  color: #409EFF;
  float: right;
}
.state {
  color: gray;
  font-size: 14px;
  font-weight: normal;
}
</style>
